
















import { toValue, useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  inject,
  PropType,
  ref,
  useAttrs
} from '@vue/composition-api';

import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';
import {
  IWorkflowFormTemplateState,
  IWorkflowFormTemplateRevisionGetters
} from '@/store/workflow-form-template';
import { IWorkflowFormField, IWorkflowFormSectionField } from '@/models';
import { SelectedWorkflowFormFieldKey } from '../tabs/WorkflowFormBuilderCalculationTab.vue';

export default defineComponent({
  name: 'WorkflowAutoCompletePicker',

  props: {
    value: String as PropType<string>,
    excludeFieldWithTemplate: Boolean
  },

  setup(props, { emit }) {
    const formFieldContext = inject(SelectedWorkflowFormFieldKey);

    if (!formFieldContext) {
      throw Error('No context provided for SelectedWorkflowFormFieldKey');
    }

    const attrs = useAttrs();

    const metaLabelVModel = useVModel(props);

    const store = useStore<IRootState>();

    const { useGetters } = createNamespacedHelpers<
      IWorkflowFormTemplateState,
      IWorkflowFormTemplateRevisionGetters
    >(store, 'workflowFormTemplate');

    const { getWorkflowFormTemplateRevisionById } = useGetters([
      'getWorkflowFormTemplateRevisionById'
    ]);

    const getMetaLabelsBeforeField = computed<string[]>(() => {
      const metaLabels: string[] = [];
      const formFields: IWorkflowFormField[] = [];

      const formTemplateRevision = getWorkflowFormTemplateRevisionById.value(
        toValue(formFieldContext!.revisionId)
      );

      if (!formTemplateRevision) {
        return metaLabels;
      }

      let sectionField = {} as IWorkflowFormSectionField;
      let sectionIndex = 0;

      while (sectionIndex < formTemplateRevision.sections!.length) {
        const sectionFields =
          formTemplateRevision.sections[sectionIndex].section_fields;

        for (
          let sectionFieldIndex = 0;
          sectionFieldIndex < sectionFields.length;
          sectionFieldIndex++
        ) {
          sectionField = sectionFields[sectionFieldIndex];
          const fieldTemplate = sectionField.field_template as IWorkflowFormField;
          const { meta_label, id, template } = fieldTemplate;

          if (
            !meta_label ||
            (formFieldContext.formFieldId &&
              formFieldContext.formFieldId === id) ||
            (props.excludeFieldWithTemplate && template != null)
          )
            continue;

          formFields.push(fieldTemplate);
          metaLabels.push(meta_label);
        }
        sectionIndex++;
      }
      return metaLabels;
    });

    return {
      metaLabelVModel,
      attrs,
      getMetaLabelsBeforeField,
      formFieldContext
    };
  }
});
